import * as Label from '@radix-ui/react-label'
import { forwardRef, type TextareaHTMLAttributes } from 'react'
import { Stack } from '../Stack'

interface ExtendedTextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  id?: string
  label: string
  error?: string
}

export const TextArea = forwardRef<HTMLTextAreaElement, ExtendedTextAreaProps>(
  ({ id, label, error, ...props }, ref) => {
    return (
      <Stack spacing="xs">
        {label && (
          <Label.Root className="ap:text-[14px] ap:font-semibold ap:text-content-primary" htmlFor={id}>
            {label}
          </Label.Root>
        )}
        <textarea
          id={id}
          ref={ref}
          {...props}
          className="ap:min-h-[132px] ap:bg-background ap:border ap:border-stroke-primary ap:w-full ap:text-base ap:mt-md ap:rounded-md ap:py-lg ap:px-xl"
        />
        {error && <p className="ap:text-content-danger">{error}</p>}
      </Stack>
    )
  },
)

TextArea.displayName = 'TextArea'
